/**
 * Fixed width for the Kin assistant drawer shell — org app (`frontend`) and partner portal (`frontend-partner`); lanes differ by `use_case`.
 */
export const ADVISOR_SIDE_PANEL_WIDTH = '436px';

/**
 * Figma Kin conversation column inset — 436px shell with ~403px message column
 * ([13406-43053](https://www.figma.com/design/bYyIivHby22hQ1jTAxVnHV/Kin-Chatbot?node-id=13406-43053)).
 * Chakra spacing token `4` = 16px horizontal padding in thread + compose regions.
 */
export const ADVISOR_MESSAGE_THREAD_HORIZONTAL_PADDING = 4;

export const ADVISOR_MESSAGE_THREAD_GAP = 4;

/**
 * Stacking order for the assistant drawer above app chrome (sidebars, headers).
 * Must sit **above** Chakra feature drawers (org app lowers drawer positioner/content
 * below `zIndex.modal`) so Kin stays usable alongside registration/filing side panels.
 * Keep this **below** modal dialogs (`zIndex.modal` = 1400), toasts, and tooltips so
 * confirmations and global overlays stay on top.
 */
export const ADVISOR_SIDE_PANEL_Z_INDEX = 1360;

/**
 * Portaled overlays (menus, popovers) opened from inside the Kin panel must sit above
 * {@link ADVISOR_SIDE_PANEL_Z_INDEX} so they are visible, but remain below Chakra ``zIndex.modal`` (1400)
 * so app modals and confirmations stay on top.
 */
export const ADVISOR_SIDE_PANEL_PORTAL_POPOVER_Z_INDEX = ADVISOR_SIDE_PANEL_Z_INDEX + 10;
